import React, { useEffect, useState } from "react";

const LoadingScreen = () => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((oldProgress) => {
                if (oldProgress === 100) {
                    clearInterval(interval);
                    return 100;
                }
                return Math.min(oldProgress + 1, 100);
            });
        }, 30); // 20ms interval for 2 seconds total

        return () => {
            clearInterval(interval);
        };
    }, []);

    return (
        <div className="loading-screen">
            <div className="loading-text">Loading...</div>
            <div
                className="progress-bar"
                style={{ width: `${progress}%` }}
            ></div>
        </div>
    );
};

export default LoadingScreen;
